import { memo, useMemo } from "react";
import { cleanUrl } from "../../../../utils/formatUtils";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Wrap case-insensitive occurrences of `query` in <mark> so search results
// show why they matched. Returns the plain string when there's no match.
const highlightMatch = (text, query) => {
  const trimmed = query?.trim();
  if (!trimmed) return text;

  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "ig"));
  if (parts.length === 1) return text;

  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <mark key={index} className="search-hit">
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export const Title = memo(({ bookmark, highlight }) => {
  const { uuid, title, url, encrypted, hint } = bookmark || {};

  const asteriskContent = useMemo(() => {
    return Array.from(
      { length: Math.floor(Math.random() * 16) + 8 },
      (_, i) => "*"
    ).join("");
  }, []);

  const randAsterisk = () => {
    return (
      <div className="mb-0 lh-1 text-muted h4 d-inline-block">
        {asteriskContent}
      </div>
    );
  };

  if (encrypted) {
    if (!hint) {
      return randAsterisk();
    }

    return (
      <OverlayTrigger
        overlay={<Tooltip id={`tooltip-hint-${uuid}`}>{hint}</Tooltip>}
        placement="top"
      >
        {randAsterisk()}
      </OverlayTrigger>
    );
  }

  const text = title ? title : cleanUrl(url);

  return (
    <div className="text-truncate h5 mb-0 pb-2 pt-1 lh-1">
      {highlight ? highlightMatch(text, highlight) : text}
    </div>
  );
});
